import { takeEvery, put } from "redux-saga/effects"
import { getCurrentUser } from "src/engine/repositories/user"
import { REQUEST_USER } from "../actions/types"
import {
  loadUserStarted,
  loadUserCompleted,
  loadUserFailed,
} from "../actions/creators"

function* requestUser() {
  yield put(loadUserStarted())

  try {
    const { data: user } = yield getCurrentUser()

    yield put(loadUserCompleted(user))
  } catch (error) {
    yield put(loadUserFailed())
  }
}

export default function* requestUserWatcher() {
  yield takeEvery(REQUEST_USER, requestUser)
}
